import { Component, OnDestroy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { LoaderService } from "src/app/_core/providers/loader.service";

@Component({
	standalone: false,
	selector: "app-loader",
	templateUrl: "./loader.component.html",
	styleUrls: ["./loader.component.scss"],
})
export class LoaderComponent implements OnDestroy {
	titleOptions: string[] = [];
	subtitleOptions: string[] = [];

	selectedTitle = this.titleOptions[0];
	selectedSubtitle = this.subtitleOptions[0];
	private langChangeSubscription: Subscription;
	private loadStartSubscription: Subscription;

	constructor(
		public _loaderService: LoaderService,
		private translateService: TranslateService,
	) {
		this.rebuildTranslations();
		this.loadStartSubscription = this._loaderService.loadStart.subscribe(() =>
			this.pickRandomText(),
		);
		this.langChangeSubscription = this.translateService.onLangChange.subscribe(
			() => {
				this.rebuildTranslations();
				this.pickRandomText();
			},
		);
	}

	get showLoading(): boolean {
		return (
			this._loaderService.displayBigLoader ||
			this._loaderService.liveRequests > 0
		);
	}

	private pickRandomText(): void {
		const titleIndex = Math.floor(Math.random() * this.titleOptions.length);
		const subtitleIndex = Math.floor(
			Math.random() * this.subtitleOptions.length,
		);
		this.selectedTitle = this.titleOptions[titleIndex];
		this.selectedSubtitle = this.subtitleOptions[subtitleIndex];
	}

	ngOnDestroy(): void {
		this.loadStartSubscription?.unsubscribe();
		this.langChangeSubscription?.unsubscribe();
	}

	private rebuildTranslations(): void {
		this.titleOptions = [
			this.translateService.instant("loader.titles.synchronizing"),
			this.translateService.instant("loader.titles.preparingData"),
			this.translateService.instant("loader.titles.updatingContext"),
			this.translateService.instant("loader.titles.processingRequest"),
		];

		this.subtitleOptions = [
			this.translateService.instant("loader.subtitles.oneMoment"),
			this.translateService.instant("loader.subtitles.applyingChanges"),
			this.translateService.instant("loader.subtitles.loadingDependencies"),
			this.translateService.instant("loader.subtitles.finalizingView"),
		];

		this.selectedTitle = this.titleOptions[0];
		this.selectedSubtitle = this.subtitleOptions[0];
	}
}
